import React, { useContext } from 'react';
import PsychometricTestMainNavbar from './PsychometricTestMainNavbar';
import Footer from './PsychometricFooter';
import { ThemeContext } from '../../contexts/ThemeContext';

const PsychometricCookiePolicy = () => {
    const { theme, fontSize, fontWeight } = useContext(ThemeContext);
    
    const styles = {
        container: {
            fontFamily: theme.paragraph.fontFamily,
            color: '#333'
        },
        mainHeading: {
            ...theme.newParagraphHeading,
            marginBottom: '1rem'
        },
        heading: {
            ...theme.headingBoldPrimaryColor,
            marginTop: '2rem',
            marginBottom: '1rem'
        },
        subHeading: {
            ...theme.headingSemiBold,
            marginTop: '1.5rem',
            marginBottom: '0.75rem'
        },
        paragraph: {
            ...theme.paragraph,
            marginBottom: '1rem',
            lineHeight: '1.6'
        },
        list: {
            ...theme.paragraph,
            marginBottom: '1rem',
            paddingLeft: '2rem'
        },
        listItem: {
            marginBottom: '0.5rem',
            lineHeight: '1.6'
        }
    };

    return (
        <div>
            <PsychometricTestMainNavbar />
            <div className="container my-5" style={styles.container}>
                <h1 style={styles.mainHeading}>Cookies Policy</h1>
                <p style={styles.paragraph}>Last updated: December 16, 2024</p>
                <p style={styles.paragraph}>This Cookies Policy explains what Cookies are and how We use them. You should read this policy so You can understand what type of cookies We use, or the information We collect using Cookies and how that information is used. This Cookies Policy has been created with the help of the <a href="https://www.termsfeed.com/cookies-policy-generator/" target="_blank">Cookies Policy Generator</a>.</p>
                <p style={styles.paragraph}>Cookies do not typically contain any information that personally identifies a user, but personal information that we store about You may be linked to the information stored in and obtained from Cookies. For further information on how We use, store and keep your personal data secure, see our Privacy Policy.</p>
                <p style={styles.paragraph}>We do not store sensitive personal information, such as mailing addresses, account passwords, etc. in the Cookies We use.</p>

                <h2 style={styles.heading}>Interpretation and Definitions</h2>
                <h3 style={styles.subHeading}>Interpretation</h3>
                <p style={styles.paragraph}>The words of which the initial letter is capitalized have meanings defined under the following conditions. The following definitions shall have the same meaning regardless of whether they appear in singular or in plural.</p>

                <h3 style={styles.subHeading}>Definitions</h3>
                <p style={styles.paragraph}>For the purposes of this Cookies Policy:</p>
                <ul style={styles.list}>
                    <li style={styles.listItem}><strong>Company</strong> (referred to as either "the Company", "We", "Us" or "Our" in this Cookies Policy) refers to Psychometric Testing.</li>
                    <li style={styles.listItem}><strong>Cookies</strong> means small files that are placed on Your computer, mobile device or any other device by a website, containing details of your browsing history on that website among its many uses.</li>
                    <li style={styles.listItem}><strong>Website</strong> refers to Psychometric Testing, accessible from <a href="https://psychometricTesting.net" rel="external nofollow noopener" target="_blank">https://psychometricTesting.net</a></li>
                    <li style={styles.listItem}><strong>You</strong> means the individual accessing or using the Website, or a company, or any legal entity on behalf of which such individual is accessing or using the Website, as applicable.</li>
                </ul>

                <h2 style={styles.heading}>Contact Us</h2>
                <p style={styles.paragraph}>If you have any questions about this Cookies Policy, You can contact us:</p>
                <ul style={styles.list}>
                    <li style={styles.listItem}>By visiting this page on our website: <a href="https://psychometrictesting.net/contact" rel="external nofollow noopener" target="_blank">https://psychometrictesting.net/contact</a></li>
                </ul>

                <h2 style={styles.heading}>The use of the Cookies</h2>
                <h3 style={styles.subHeading}>Type of Cookies We Use</h3>
                <p style={styles.paragraph}>Cookies can be "Persistent" or "Session" Cookies. Persistent Cookies remain on your personal computer or mobile device when You go offline, while Session Cookies are deleted as soon as You close your web browser.</p>
                <p style={styles.paragraph}>We use both session and persistent Cookies for the purposes set out below:</p>
                <ul style={styles.list}>
                    <li style={styles.listItem}>
                        <p style={styles.paragraph}><strong>Necessary / Essential Cookies</strong></p>
                        <p style={styles.paragraph}>Type: Session Cookies</p>
                        <p style={styles.paragraph}>Administered by: Us</p>
                        <p style={styles.paragraph}>Purpose: These Cookies are essential to provide You with services available through the Website and to enable You to use some of its features.</p>
                    </li>
                    <li style={styles.listItem}>
                        <p style={styles.paragraph}><strong>Functionality Cookies</strong></p>
                        <p style={styles.paragraph}>Type: Persistent Cookies</p>
                        <p style={styles.paragraph}>Administered by: Us</p>
                        <p style={styles.paragraph}>Purpose: These Cookies allow us to remember choices You make when You use the Website.</p>
                    </li>
                </ul>

                <h3 style={styles.subHeading}>Your Choices Regarding Cookies</h3>
                <p style={styles.paragraph}>If You prefer to avoid the use of Cookies on the Website, first You must disable the use of Cookies in your browser and then delete the Cookies saved in your browser associated with this website.</p>
                <p style={styles.paragraph}>If You do not accept Our Cookies, You may experience some inconvenience in your use of the Website and some features may not function properly.</p>

                <h3 style={styles.subHeading}>More Information about Cookies</h3>
                <p style={styles.paragraph}>You can learn more about cookies here: <a href="https://www.termsfeed.com/blog/cookies/" target="_blank">All About Cookies by TermsFeed</a>.</p>
            </div>
            <Footer />
        </div>
    );
};

export default PsychometricCookiePolicy; 